const WORKER_LAYOUT_DATA_KEYS = new Set([
  'id',
  'source',
  'target',
  'parent',
  'label',
  'vertexType',
  'type',
  'nodeType',
]);

const isWorkerLayoutScalar = (value) => (
  value == null
  || typeof value === 'string'
  || typeof value === 'number'
  || typeof value === 'boolean'
);

export const sanitizeWorkerDataForLayout = (data = {}) => {
  const cleanData = {};
  for (const key of WORKER_LAYOUT_DATA_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
    const value = data[key];
    if (isWorkerLayoutScalar(value)) {
      cleanData[key] = value;
    }
  }
  return cleanData;
};